import { SandTableMapContainer } from '@components/SandTableMapContainer';
import { MEDIA_DOMAIN, PUBLIC_DOMAIN } from '@constants';
import type { STMap } from '@types';
import { useEffect, useRef } from 'react';
import { stEnterAmap } from '../../../sandTable/STAMap';

interface Props {
  data: STMap;
}

export function LayerMap({ data }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (containerRef.current) {
      stEnterAmap.init({
        mediaDomain: MEDIA_DOMAIN,
        publicDomain: PUBLIC_DOMAIN,
        target: containerRef.current,
        data,
      });
    }
    return () => {
      stEnterAmap.removeMap();
    };
  }, [data]);
  return (
    <SandTableMapContainer className="absolute inset-0" ref={containerRef} />
  );
}
